var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenownIsotype = function SvgRenownIsotype(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "260.91 -1.59 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#renown-isotype_svg__a)",
    d: "M283.725.913c-2.769 9.738-10.153 17.414-19.518 20.281-1.175.363-1.175 2.078 0 2.44 9.36 2.867 16.749 10.544 19.518 20.282.346 1.217 2.019 1.217 2.37 0 2.769-9.738 10.152-17.415 19.518-20.282 1.174-.362 1.174-2.077 0-2.44-9.361-2.867-16.749-10.543-19.518-20.281-.346-1.217-2.019-1.217-2.37 0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "renown-isotype_svg__a",
    x1: 284.91,
    x2: 267.027,
    y1: -2.82,
    y2: 41.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21FFB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080FF"
  })))));
};
export default SvgRenownIsotype;